import React from 'react'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import Modal from '@groovehq/internal-design-system/lib/components/Modal/Modal'
import outlook from '@groovehq/internal-design-system/lib/assets/icons/logos/outlook.png'
import gmail from '@groovehq/internal-design-system/lib/assets/icons/logos/gmail.png'
import goDaddy from '@groovehq/internal-design-system/lib/assets/icons/logos/go-daddy.png'
import googleGroups from '@groovehq/internal-design-system/lib/assets/icons/logos/google-groups.png'
import zoho from '@groovehq/internal-design-system/lib/assets/icons/logos/zoho.png'
import cpanel from 'assets/logos/cpanel.png'

import { styles } from './styles'

const links = [
  {
    Icon: <img src={gmail} alt="Gmail logo" />,
    name: 'Gmail Alias',
    url: 'https://help.groovehq.com/help/forwarding-an-alias-from-gmail',
  },
  {
    Icon: <img src={googleGroups} alt="Google group logo" />,
    name: 'Google group',
    url:
      'https://help.groovehq.com/help/how-to-forward-email-from-a-google-group',
  },
  {
    Icon: <img src={outlook} alt="Outlook logo" />,
    name: 'Outlook Alias',
    url: 'https://help.groovehq.com/help/how-to-forward-email-from-outlook',
  },
  {
    Icon: <img src={goDaddy} alt="Go Daddy logo" />,
    name: 'Go Daddy',
    url: 'https://help.groovehq.com/help/how-to-forward-email-from-godaddy',
  },
  {
    Icon: <img src={zoho} alt="Zoho mail logo" />,
    name: 'Zoho Mail',
    url: 'https://help.groovehq.com/help/how-to-forward-email-from-zoho',
  },
  {
    Icon: <img src={cpanel} alt="CPanel logo" />,
    name: 'CPanel',
    url: 'https://help.groovehq.com/help/how-to-forward-email-from-cpanel',
  },
]

const ForwardingGuides = () => {
  return (
    <Modal.AttachedContainer
      title="Step-by-step forwarding guides"
      css={styles.forwardingWrapper}
    >
      <div>
        {links.map(link => (
          <Button
            type="tertiary"
            customIcon={link.Icon}
            as="a"
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            key={link.name}
            css={styles.forwardingGuidesBtn}
          >
            {link.name}
          </Button>
        ))}
      </div>
    </Modal.AttachedContainer>
  )
}

export default ForwardingGuides
